import { render, staticRenderFns } from "./p_job_news.vue?vue&type=template&id=5b094219&scoped=true&"
import script from "./p_job_news.vue?vue&type=script&lang=js&"
export * from "./p_job_news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b094219",
  null
  
)

export default component.exports